export enum DialerQueueOrder {
  STANDARD = "STANDARD",
  CLOSING_WINDOW_FIRST = "CLOSING_WINDOW_FIRST",
}
